import { render, staticRenderFns } from "./TicketHistory.vue?vue&type=template&id=9d60d182&scoped=true&"
import script from "./TicketHistory.vue?vue&type=script&lang=js&"
export * from "./TicketHistory.vue?vue&type=script&lang=js&"
import style0 from "./TicketHistory.vue?vue&type=style&index=0&id=9d60d182&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d60d182",
  null
  
)

export default component.exports